export default "__VITE_ASSET__7YevIhxi__"